import React from 'react';

import { Colors, IconClobeFill, Text } from '@revenuemarket/cds';
import { Flex, IconButton, IconMinusLine, IconXLine } from '@revenuemarket/vds';

import { HeaderWrapper } from './style';

interface ScrapeFloatingPanelHeaderProps {
  onClickClose: () => void;
  onClickToggleMinimize: () => void;
}

const ScrapeFloatingPanelHeader: React.FC<ScrapeFloatingPanelHeaderProps> = ({
  onClickClose,
  onClickToggleMinimize,
}) => {
  return (
    <HeaderWrapper>
      <Flex align="center" gap={4}>
        <IconClobeFill width={32} height={32} />
        <Text textStyle="18_600" style={{ color: Colors.gray900 }}>
          데이터 수집
        </Text>
      </Flex>
      <Flex align="center" gap={4}>
        <IconButton
          buttonSize="s"
          buttonType="ghost"
          icon={<IconMinusLine fill={Colors.gray700} />}
          tooltipMessage="최소화"
          onClick={onClickToggleMinimize}
        />
        <IconButton
          buttonSize="s"
          buttonType="ghost"
          icon={<IconXLine fill={Colors.gray700} />}
          tooltipMessage="닫기"
          onClick={onClickClose}
        />
      </Flex>
    </HeaderWrapper>
  );
};

export default ScrapeFloatingPanelHeader;
